export default __webpack_public_path__ + "static/breads2-7d1d63a792873ff0320eb82e51c88fdd.jpg";